import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { resolveImageUrl } from '@/utils/imageUrl';

export const Footer = ({ settings }) => {
  return (
    <footer className="bg-[#0077D4] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Name */}
          <div>
            <img
              src={resolveImageUrl(settings?.logo_url) || ''}
              alt={settings?.company_name || 'HKE Bedachung'}
              className="h-16 w-auto brightness-0 invert mb-4"
              style={{ display: resolveImageUrl(settings?.logo_url) ? 'block' : 'none' }}
            />
            <p className="text-slate-400 text-sm mt-4 leading-relaxed">
              {settings?.company_name || 'HKE Bedachung Ertel'} — Ihr zuverlässiger Dachdecker-Meisterbetrieb in Dresden seit 1998.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wider mb-6">Kontakt</h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-[#CC2229]" />
                <span className="text-slate-300">{settings?.phone || '0351-2038530'}</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-[#CC2229]" />
                <span className="text-slate-300">{settings?.mobile || '0171-7714831'}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-[#CC2229]" />
                <span className="text-slate-300">{settings?.email || 'hke-bedachung@t-online.de'}</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin size={16} className="text-[#CC2229]" />
                <span className="text-slate-300">{settings?.address || 'Teichplatz 7, 01259 Dresden'}</span>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wider mb-6">Rechtliches</h4>
            <div className="space-y-3 text-sm">
              <Link to="/impressum" className="block text-slate-300 hover:text-white transition-colors" data-testid="footer-impressum">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-slate-300 hover:text-white transition-colors" data-testid="footer-datenschutz">
                Datenschutzerklärung
              </Link>
              <Link to="/admin" className="block text-slate-400 hover:text-slate-300 transition-colors text-xs mt-6" data-testid="footer-admin-link">
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} {settings?.company_name || 'HKE Bedachung Ertel'}. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};
